/* ═══════════════════════════════════════════
   NICCHIA PARFUMS — Homepage Scripts
   For Shopify Ella Theme Integration
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  // Intersection Observer for scroll reveal animations
  var nicchiaObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  // Initialize on DOM ready
  function initNicchia() {
    document.querySelectorAll('.nicchia-reveal').forEach(function(el) {
      nicchiaObserver.observe(el);
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNicchia);
  } else {
    initNicchia();
  }

  // Also re-initialize when Shopify Theme Editor loads sections
  document.addEventListener('shopify:section:load', function() {
    initNicchia();
  });
})();
